import React from "react";
import Navbar from "../../Shared/NavBar/Navbar";
import AnalyticsMainContent from "./Components/AnalyticsMainContent";

const Analytics = () => {
  return (
    <div className="main-wrapper ">
      <Navbar />
      <AnalyticsMainContent />
    </div>
  );
};

export default Analytics;
